export const PLANS = [
  {
    productId: 'd03c8fa0-4464-4ee7-a979-0700e2f5d290',
    name: 'Fiber 200',
    price: '$29.99',
    duration: 'per month with Auto Pay, for 12 months',
    isFastest: false,
    isBestValue: false,
    legalKey: 'internet200',
    details: {
      capability: {
        download_speed: '200 megabits per second',
        upload_speed: '200 megabits per second',
        browsing_streaming: true,
        remote_work: false,
        smart_devices: false,
        large_households: false,
      },
      offers_benefits: {
        visa_reward_card: false,
        fastest_wifi: false,
        tech_upgrade: false,
        premium_services: false,
      },
      technical_specs: {
        movie_download_1080p: '5.3 minutes',
        songs_download: '19 seconds',
        game_download: '35.8 minutes',
        photos_upload: '15 seconds',
      },
    },
  },
  {
    productId: 'c75fb0df-6d48-4a06-bb10-3ee47a8d3d28',
    name: 'Fiber 500',
    price: '$44.99',
    duration: 'per month with Auto Pay, for 12 months',
    isFastest: false,
    isBestValue: false,
    legalKey: 'internet500',
    details: {
      capability: {
        download_speed: '500 megabits per second',
        upload_speed: '500 megabits per second',
        browsing_streaming: true,
        remote_work: true,
        smart_devices: false,
        large_households: false,
      },
      offers_benefits: {
        visa_reward_card: false,
        fastest_wifi: false,
        tech_upgrade: false,
        premium_services: false,
      },
      technical_specs: {
        movie_download_1080p: '2.2 minutes',
        songs_download: '8 seconds',
        game_download: '14.3 minutes',
        photos_upload: '6 seconds',
      },
    },
  },
  {
    productId: '2b09989e-1696-4cc2-b13c-7e0950b74588',
    name: 'Fiber 1 Gig',
    price: '$29.99',
    duration: 'per month with Auto Pay, for 12 months',
    isFastest: false,
    isBestValue: false,
    legalKey: 'internetgig',
    details: {
      capability: {
        download_speed: '1000 megabits per second',
        upload_speed: '1000 megabits per second',
        browsing_streaming: true,
        remote_work: true,
        smart_devices: true,
        large_households: true,
      },
      offers_benefits: {
        visa_reward_card: false,
        fastest_wifi: false,
        tech_upgrade: false,
        premium_services: false,
      },
      technical_specs: {
        movie_download_1080p: '1.1 minutes',
        songs_download: '4 seconds',
        game_download: '7.2 minutes',
        photos_upload: '3 seconds',
      },
    },
  },
  {
    productId: '67e4d13f-65f8-485b-8ebc-9c922e72c1a2',
    name: 'Fiber 2 Gig',
    price: '$99.99',
    duration: 'per month with Auto Pay',
    isFastest: false,
    isBestValue: true,
    legalKey: 'internet2gig',
    details: {
      capability: {
        download_speed: '2000 megabits per second',
        upload_speed: '2000 megabits per second',
        browsing_streaming: true,
        remote_work: true,
        smart_devices: true,
        large_households: true,
      },
      offers_benefits: {
        visa_reward_card: true,
        fastest_wifi: false,
        tech_upgrade: false,
        premium_services: false,
      },
      technical_specs: {
        movie_download_1080p: '32 seconds',
        songs_download: '2 seconds',
        game_download: '3.6 minutes',
        photos_upload: '2 seconds',
      },
    },
  },
  {
    productId: '4a7c0a86-9b8d-4b5f-b60f-10849155f5c0',
    name: 'Fiber 5 Gig',
    price: '$299.99',
    duration: 'per month with Auto Pay, for 12 months',
    isFastest: false,
    isBestValue: false,
    legalKey: 'internet5gig',
    details: {
      capability: {
        download_speed: '5000 megabits per second',
        upload_speed: '5000 megabits per second',
        browsing_streaming: true,
        remote_work: true,
        smart_devices: true,
        large_households: true,
      },
      offers_benefits: {
        visa_reward_card: false,
        fastest_wifi: true,
        tech_upgrade: false,
        premium_services: false,
      },
      technical_specs: {
        movie_download_1080p: '12 seconds',
        songs_download: '<1 seconds',
        game_download: '1.4 minutes',
        photos_upload: '1 seconds',
      },
    },
  },
  {
    productId: '4fbc7f33-616d-4923-bbb7-e88e46658917',
    name: 'Fiber 7 Gig',
    price: '$299.99',
    duration: 'per month with Auto Pay, for 12 months',
    isFastest: true,
    isBestValue: false,
    legalKey: 'internet7gig',
    details: {
      capability: {
        download_speed: '7000 megabits per second',
        upload_speed: '7000 megabits per second',
        browsing_streaming: true,
        remote_work: true,
        smart_devices: true,
        large_households: true,
      },
      offers_benefits: {
        visa_reward_card: false,
        fastest_wifi: true,
        tech_upgrade: true,
        premium_services: true,
      },
      technical_specs: {
        movie_download_1080p: '10 seconds',
        songs_download: '<1 seconds',
        game_download: '1.03 minutes',
        photos_upload: '<1 seconds',
      },
    },
  },
];

export const PLAN_COMPARISON = [
  {
    title: 'Capability',
    fields: [
      {
        label: 'Download & upload speed up to',
        key: 'capability.download_speed',
        legalKey: 'internet_speed',
      },
      {
        label: 'Browsing and streaming',
        key: 'capability.browsing_streaming',
      },
      {
        label: 'Remote work and virtual learning for several people',
        key: 'capability.remote_work',
      },
      {
        label: 'Ideal for smart devices and security systems',
        key: 'capability.smart_devices',
      },
      {
        label: 'Ideal for large households',
        key: 'capability.large_households',
      },
    ],
  },
  {
    title: 'Offers & Benefits',
    fields: [
      {
        label: 'Visa® Reward Card up to $200',
        key: 'offers_benefits.visa_reward_card',
        legalKey: 'vrcProrated',
      },
      {
        label: "Industry's fastest Wi-Fi technology included, with Wi-Fi 7",
        key: 'offers_benefits.fastest_wifi',
      },
      {
        label: '3-year tech upgrade',
        key: 'offers_benefits.tech_upgrade',
        legalKey: 'techUpgrade',
      },
      {
        label: 'Premium services included, a $899 value',
        key: 'offers_benefits.premium_services',
        legalKey: 'premiumServices',
      },
    ],
  },
  {
    title: 'Technical Specs',
    fields: [
      {
        label: 'Time to download a 2-hour movie in 1080p',
        key: 'technical_specs.movie_download_1080p',
      },
      {
        label: 'Time to download 100 3-minute songs',
        key: 'technical_specs.songs_download',
      },
      {
        label: 'Time to download a 50GB PC game',
        key: 'technical_specs.game_download',
      },
      {
        label: 'Time to upload 100 photos',
        key: 'technical_specs.photos_upload',
      },
    ],
  },
];

export const LEGAL_NOTE =
  'The estimated download/upload time provided is based on theoretical maximum speeds under ideal conditions. Actual speeds may vary significantly due to a variety of factors, most notably the capabilities of your hardware. The rate at which data can be received (downloaded) or sent (uploaded) is contingent upon the performance of your device’s internal components, including, but not limited to, the hard drive (HDD or SSD), network interface card (NIC), and processor (CPU). Older or lower-specification devices may not achieve the speeds suggested due to slower read/write capabilities and data processing speeds. Additionally, external factors such as network congestion, the quality of the connection (including wireless signal strength), and the performance of intermediate network devices (like routers and modems) can also impact the actual data transfer rate. It is advised to consult with a technical professional to understand the realistic speeds you can expect based on your specific hardware and network setup.';
